import { render } from "./LegalPage.vue?vue&type=template&id=7f64dc96&scoped=true"
import script from "./LegalPage.vue?vue&type=script&lang=js"
export * from "./LegalPage.vue?vue&type=script&lang=js"

import "./LegalPage.vue?vue&type=style&index=0&id=7f64dc96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f64dc96"]])

export default __exports__